import LogRocket from 'logrocket';
import type { TSdk } from '#observability/observability.types.ts';
import type { TLogRocketOptions } from './logRocket.types.ts';

const logRocketSdk: TSdk = {
  identify: ({ userId, traits }) => LogRocket.identify(userId, traits),
  anonymize: () => LogRocket.startNewSession(),
  track: (name, properties) => LogRocket.track(name, properties),
};

export const initLogRocket = ({ appId, release }: TLogRocketOptions): TSdk => {
  LogRocket.init(appId, { release });

  return logRocketSdk;
};
